import { Card } from "antd";

const StatCard: React.FC<{
  body: React.ReactNode;
  bodyStyle?: React.CSSProperties;
  className?: string;
}> = ({ body, bodyStyle, className }) => {
  return (
    <Card className={className} bodyStyle={bodyStyle}>
      {body}
    </Card>
  );
};

export default StatCard;
